import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { GuestService } from '../modules/core/services/guest.service';

import { CONSTANTS } from '../constants/constants';
import * as fromRoot from '../reducers';
import { Store } from '@ngrx/store';
import { BookingService } from '../modules/core/services/booking.service';
import { navGuardUtil } from '../utils/nav-guard.util';

export const cruiseDetailsNavigationGuard: CanActivateFn = (): Observable<any> => {
	const store: Store<fromRoot.AppState> = inject(Store<fromRoot.AppState>);
	const guestService: GuestService = inject(GuestService);
	const bookingService: BookingService = inject(BookingService);
	const router: Router = inject(Router);
	const constants: any = inject(CONSTANTS); 

	return navGuardUtil({
      store: store,
      router: router,
      routePath: constants.ROUTES.SELECT_GUESTS_FOR_CHECKIN,
      routeErrorPath: constants.ROUTES.ERROR,
      isProgressBarEnabled: bookingService.isProgressBarEnabled,
      infoCompleted: guestService.isOnboardExpensesCompleted
    }); 
}
